import { Suspense } from "react";
import Loading from "../../components/Loading/Loading";
import ServiceCount from "../../components/ServiceCount";
import { useMediaQuery } from "react-responsive";
import "../../styles/ContactUs.css";
import WhatWeDo from "../../components/AboutUsComponents/WhatWeDo";
import AboutBanner from "../../components/AboutUsComponents/AboutBanner";
import "../../styles/AboutUs/AboutUs.css";
import WhoWeAre from "../../components/AboutUsComponents/WhoWeAre";
import MissionVision from "../../components/AboutUsComponents/MissionVision";
import MeetTheTeam from "../../components/AboutUsComponents/MeetTheTeam";

// const data = [
//   {
//     count: 51, // Numeric for animation
//     suffix: "k+", // Added separately for display
//     desc: "Templates <br/> Downloaded"
//   },
//   {
//     count: 51,
//     suffix: "k+",
//     desc: "Startups <br/> Empowered"
//   },
//   {
//     count: 51,
//     suffix: "k+",
//     desc: "Countries <br/> Global Reach"
//   },
//   {
//     count: 50,
//     suffix: "+",
//     desc: "Courses <br/> Delivered"
//   },
//   {
//     count: 5,
//     suffix: "k+",
//     desc: "Entrepreneurs <br/> Trained"
//   }
// ];
const AboutUs = () => {
  return (
    <Suspense fallback={<Loading />}>
      <div id="about-us-container">
        <AboutBanner />
        <WhoWeAre />
        <MissionVision />
        <hr className="hr" />
        <div id="service-container">
          <ServiceCount />
        </div>
        <WhatWeDo />
        <MeetTheTeam />
      </div>
    </Suspense>
  );
};

export default AboutUs;
